export var EqAction;
(function (EqAction) {
    EqAction["LoadModel"] = "LoadModel";
    EqAction["LoadQuery"] = "LoadQuery";
    EqAction["LoadQueryList"] = "LoadQueryList";
    EqAction["NewQuery"] = "NewQuery";
    EqAction["SaveQuery"] = "SaveQuery";
    EqAction["RemoveQuery"] = "RemoveQuery";
    EqAction["SyncQuery"] = "SyncQuery";
    EqAction["FetchData"] = "FetchData";
    EqAction["GetValueList"] = "GetValueList";
    EqAction["ExportResult"] = "ExportResult";
    EqAction["GetQueryFile"] = "GetQueryFile";
    EqAction["UploadQueryFile"] = "UploadQueryFile";
})(EqAction || (EqAction = {}));
//# sourceMappingURL=eq_actions.js.map